import useClassNames from '@medflex/hooks/useClassNames';
import PropTypes from 'prop-types';
import React from 'react';

const Switch = ({ children, onChange, className, ...props }) => {
  const cn = useClassNames(
    () => [!props.hidden && 'flex', 'flex-wrap', 'space-x-2', 'lg:space-x-4', className],
    [className],
  );

  const handleChange = e => {
    const { value } = e.target;
    if (value) onChange({ value });
  };

  return (
    // eslint-disable-next-line
    <div className={cn} onClick={handleChange} {...props}>
      {children}
    </div>
  );
};

Switch.propTypes = {
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.array,
    PropTypes.object,
  ]),
  hidden: PropTypes.bool,
};

Switch.defaultProps = {
  onChange: () => {},
  hidden: false,
};

export default Switch;
